import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { checkStatus ,setLoader} from '../../../../util/util';
import {  ExcelRenderer } from 'react-excel-renderer';
import { Alert,AlertConfirm, AlertCommit } from '../../../Modals/AlertBar';
import ExportExcelPoi from '../ExportExcel/ExportExcelPoi';
import {defaultColors as m_POIColor,defaultIcons as m_POIIcon} from '../../UserControl/IconColorPicker/POIColorPicker.';
// import {defaultColors as m_CarColor,defaultIcons as m_CarIcon} from '../../UserControl/IconColorPicker/IconColorPicker';

class ImportExportPoi extends Component {

    constructor() {
        super();
        this.state = {
            cols:[],
            rows:[],
            objExcelList: [],
            poiList: [],
            selectedGroup: '',
            poiGroupList:[],
            selectPoiGroup:'0',
        }
    }

    componentDidMount(){
        this.getPOIGroupList();
    }

    getPOIGroupList() {
        const { token} = this.props;
        fetch(`http://203.150.199.244/api/admin/getPOIGroupList`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token": token
            },
            body: JSON.stringify({
            })
        })
            .then(response => { return checkStatus(response)})
            .then(data => {
                this.setState({
                    poiGroupList: data.RESULT_DATA
                })
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    getDeviceListById() {
        const { token} = this.props;
        const { selectedGroup,selectPoiGroup } = this.state;
        // const groupName = selectedGroup.label === 'ไม่ระบุกลุ่ม' || !selectedGroup ? null : selectedGroup.label;
        let groupName = '';
        if(selectPoiGroup !== 'ไม่มีกลุ่ม')
            groupName = selectPoiGroup;

        if(selectPoiGroup !== '0')
            groupName = '0';

        console.log('groupName',groupName)

        fetch(`http://203.150.199.244/api/admin/getPOIListByGroup`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token": token
            },
            body: JSON.stringify({
                "groupName": groupName
            })
        })
            .then(response => { return checkStatus(response)})
            .then(data => {
                console.log(data)
                // this.setState({
                //     poiList: data.RESULT_DATA
                // })
                let result = [];
                if(data.RESULT_DATA != null && data.RESULT_DATA != undefined && data.RESULT_DATA.length > 0)
                    result = data.RESULT_DATA;

                let list = [];
                result.map((poi) => {

                    list.push({
                        "name" : poi.name,
                        "group" :  poi.group,
                        "radius" : poi.radius,
                        "latitude" : poi.location == null ? '' : poi.location.latitude,
                        "longitude" : poi.location == null ? '' : poi.location.longitude,
                        "icon" : poi.icon == null ? '' : poi.icon.name +'|'+ poi.icon.color +'|',
                    })
                })
                console.log('objList',list)
                this.setState({
                    poiList : list
                })
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    onChageFile = (e) => {
        let fileObj = e.target.files[0];
        //just pass the fileObj as parameter
        ExcelRenderer(fileObj, (err, resp) => {
            if(err){
                console.log('err:', err);
                Alert('รูปแบบไฟล์ไม่ถูกต้อง กรุณาเลือกเฉพาะไฟล์ Excel​')
            }
            else{
                console.log('cols',resp.cols)
                console.log('rows',resp.rows)
                this.setState({
                    cols: resp.cols,
                    rows: resp.rows
                },() => this.validateData());
            }
        });
    }

    validateData = () => {
        const { cols, rows } = this.state;
        let objList = [];
        if (cols.length !== 6) {
            Alert('รูปแบบไฟล์ไม่ถูกต้อง')
        } else {
            for (var i = 1; i < rows.length; i++){

                var iconName=m_POIIcon[0];
                var iconColor=m_POIColor[0] ;
                if(rows[i][1] != undefined){
                    var icon = rows[i][1].split('|');
                    iconName = icon[0];
                    iconColor = icon[1];
                }
                    
                objList.push({
                    "name" : rows[i][2],
                    "group" :  rows[i][0],
                    "radius" : rows[i][3],
                    "location" : {
                        "latitude" : rows[i][4],
                        "longitude" : rows[i][5],
                    },
                    "icon" : {
                        "name" : iconName,
                        "color" : iconColor,
                        "is_small" : false
                    }
                })
            }
                
        }
        console.log('objList',objList)
        this.setState({objExcelList: objList});
    }

    onSubmitUpload = () => {
        const { objExcelList } = this.state;
        let poiList = [];
        poiList = objExcelList;
        console.log(poiList)
        const { user_id, user_name, token } = this.props;
        if (poiList && poiList.length > 0) {
            setLoader(true);
            fetch(`http://203.150.199.244/api/admin/newManyPOI`, {
                method: 'post',
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    // "user_id": user_id,
                    // "user_name": user_name,
                    "token": token
                },
                body: JSON.stringify(
                    poiList
                )
            })
                .then(response => { return checkStatus(response)})
                .then(data => {
                    console.log('data:', data)
                    if (data.RESULT_MESSAGE === 'Successfull') {
                        AlertCommit('อัพโหลดสำเร็จ');
                    } else {
                        Alert('ข้อมูลผิดพลาด กรุณาอัพโหลดใหม่');
                    }
                    setLoader(false);
                }), 
                (error) => {
                  console.log("error",error)
                  setLoader(false);
                }
        }

    }

    handleClickDownloadTemplate = () => {
        const value = require('../../../../../downloads/uploadPoiTemplete.xlsx');
        window.location = value;
    }

    deleteAllPoi(){

        AlertConfirm("ลบ POI","คุณต้องการลบ POI หรือไม่").then(isOk=>{
            if(isOk){
                const { token } = this.props;
                const { deviceSelectID } = this.state;

                fetch(`http://203.150.199.244/api/admin/deletePOIAll`, {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "token":token,
                    },
                    body: JSON.stringify({
                    })
                })
                    .then(response => { return checkStatus(response)})
                    .then((data) => {

                        if(data.RESULT_STATUS == "000")
                            AlertCommit(true,"ลบข้อมูลเรียบร้อยแล้ว");
                        else{
                            AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
                        }

                    }).catch(function (err) {
                        console.log('err:', err);
                        // POST failed...
                    });
                }
            });
    }

  render() {
      console.log('selectPoiGroup',this.state.selectPoiGroup)
    return (
        <div>
           
           <div className="container">
           <div className="row">
        <div className="card" style={{width:'100%'}}>
            <div className="card-header">
                <strong>ส่งออกข้อมูล POI</strong>
            </div>
            <div className="card-body">
                <div className="form-group row">
                    
                    <div className=" col-md-2" >
                        <label htmlFor="upload" className="pull-right">กลุ่ม</label>
                    </div>
                    <div className="col-md-10">
                        {/* <select className="form-control" id="example-text-input">
                            <option>-- ทั้งหมด -- (102)</option>
                            <option>ศูนย์บริการISUZU (35)</option>
                            <option>Big Cola (1)</option>
                            <option>ลูกค้า (1)</option>
                            <option>Big cola (1) </option>
                            <option>ศูนย์บริการISUZU (1)</option>
                        </select> */}
                        <select className="form-control" onChange={(e) => this.setState({selectPoiGroup:e.target.value})} >
                            <option value="0" selected >-- ทั้งหมด --</option>
                            {
                            this.state.poiGroupList.map((item,key) => {
                                return(
                                    <option key={key} value={item.id}>{item.desc}</option> 
                                )
                            })
                            }
                        </select>
                    </div>
                    <br />
                    <div className="offset-2 col-md-2">
                        <button type="submit" className="btn btn-primary" onClick={() => this.getDeviceListById()}>บันทึกข้อมูล</button>
                    </div>
                    {this.state.poiList && this.state.poiList.length > 0 &&
                   
                        <ExportExcelPoi dataExcel={this.state.poiList}  />
                    }
                </div>
               
            </div>
        </div>
        </div>
        <br/>
        <div className="row">
            <div className="card" style={{width:'100%'}}>
                    <div className="card-header">
                        <strong>นำเข้าข้อมูล POI</strong>
                    </div>
                    <div className="card-body">
                        {/* <div className="form-group row">
                            <label htmlFor="upload" className="col-md-2">XLSX File
                            </label>
                            <div className="col-md-10">
                                <input onChange={e => this.onChageFile(e)} className="form-control" style={{opacity: 1,position:'inherit'}} type="file" id="upload" accept=".xlsx, .xls" />
                            </div>
                        </div>
                        <div className="form-group row">
                            <div className=" col-md-2" />
                            <div className="col-md-10">
                                <button type="submit" className="btn btn-primary">บันทึกข้อมูล</button>
                            </div>
                        </div> */}

                        <div className="form-group row">
                            <div className=" col-md-2" >
                                <label htmlFor="upload" className="pull-right">XLSX File</label>
                            </div>
                            <div className="col-md-10">
                                <input onChange={e => this.onChageFile(e)} className="form-control" style={{opacity: 1,position:'inherit'}} type="file" id="upload" accept=".xlsx, .xls" />
                            </div>
                            <br/>
                            <div className="offset-2 col-md-2">
                                <button onClick={() => this.onSubmitUpload()} type="submit" className="btn btn-primary">บันทึกข้อมูล</button>
                            </div>
                            <div className="col-md-2">
                                <button onClick={() => this.handleClickDownloadTemplate()} className="btn btn-primary">ดาวน์โหลดแม่แบบ</button>
                            </div>
                        </div>

                    </div>
                    
            </div>
        </div>
        <br/>
        <div className="row">
            <div className="card" style={{width:'100%'}}>
            <div className="card-header">
                <strong>ล้างข้อมูล POI</strong>
            </div>
            <div className="card-body">
            <div className="form-group row">
                <div className="offset-2 col-1">
                    <button type="button" className="btn btn-danger" onClick={() => {this.deleteAllPoi()}}>ล้างข้อมูล</button>
                </div>
                <div className="col-9">
                    <span style={{color: 'red'}}>*** ข้อมุล POI จะหายทั้งหมด กรุณาทำการสำรองข้อมุลก่อนกด</span>
                </div>
            </div>
                
            </div>
        </div> 
        </div>        
           </div>
                         
</div>
    );
  }
}

export default ImportExportPoi;



// WEBPACK FOOTER //
// ./src/app/view/components/AdminConfig/Content/ImportExportPoi.js